export interface MypExpiry {
  mode?: string
  days?: number | string
  date?: string
}

// Voucher validity ("period", in days) implied by an MYP program's expiry.
// Server-side twin exists - keep both in sync.
export const derivePeriodFromMypExpiry = (expiry?: MypExpiry | null, now: Date = new Date()): number | null => {
  if (!expiry) return null
  if (expiry.mode === 'DAYS_FROM_LOAD') {
    const days = Number(expiry.days)
    return Number.isInteger(days) && days > 0 && String(expiry.days).trim() !== '' ? days : null
  }
  if (expiry.mode === 'FIXED_DATE') {
    const date = expiry.date
    if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return null
    const end = new Date(`${date}T23:59:59.999+08:00`).getTime()
    if (Number.isNaN(end)) return null
    return Math.max(1, Math.ceil((end - now.getTime()) / 86400000))
  }
  return null
}
